var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveOrScheduleJobQuickAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360 210.93h-330c-16.569 0-30-13.431-30-30v-75c0-8.284 6.716-15 15-15h360c8.284 0 15 6.716 15 15v75c0 16.569-13.431 30-30 30z",
    fill: "#f98845"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m375 90.93h-180v120h165c16.569 0 30-13.433 30-30v-75c0-8.285-6.716-15-15-15z",
    fill: "#ec4c36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m375 450.93h-360c-8.284 0-15-6.716-15-15v-255h390v255c0 8.285-6.716 15-15 15z",
    fill: "#f3f5f9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m195 450.93h180c8.284 0 15-6.716 15-15v-255h-195z",
    fill: "#e1e6f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Edit_Calendar_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m75 150.93c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#515866"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315 150.93c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#353d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 285.93,
    fill: "#b8c6e6",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 285.93,
    fill: "#a3b4d9",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 345.93,
    fill: "#b8c6e6",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 345.93,
    fill: "#b8c6e6",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 345.93,
    fill: "#b8c6e6",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 345.93,
    fill: "#a3b4d9",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 285.93,
    fill: "#a3b4d9",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 285.93,
    fill: "#b8c6e6",
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 285.93,
    fill: "#b8c6e6",
    r: 15
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m453.584 394.098c-1.041-2.083-1.584-4.38-1.584-6.708v-266.608c0-16.538 13.447-30 30-30s30 13.462 30 30v266.607c0 2.329-.542 4.625-1.584 6.708l-15 48.68c-5.528 11.056-21.305 11.056-26.833 0z",
    fill: "#b8c6e6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a3b4d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m210 345.93c0-8.286-6.716-15-15-15v30c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 285.93c0-8.286-6.716-15-15-15v30c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.416 442.777 15-48.68c1.042-2.082 1.584-4.378 1.584-6.707v-266.608c0-16.538-13.447-30-30-30v360.286c5.325 0 10.653-2.763 13.416-8.291z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveOrScheduleJobQuickAction);
export default __webpack_public_path__ + "static/media/approve-or-schedule-job-quick-action.320a52aa859da5603e03f86b550bf1bb.svg";
export { ForwardRef as ReactComponent };